// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthLayout_wrapper__BDEx7","content":"AuthLayout_content__1Ff4F"};